import { Directive } from '@angular/core';

@Directive({
	selector: '[appIfOnDom]'
})
export class IfOnDomDirective {
	constructor() {}
}
